import styled from 'styled-components'
const ModalContainer = styled.div`
    display: none;
`
const Container = styled.div`
 max-width: 767px;
 width: 100%;

`
const Heading = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
 > h6 {
        text-align: left;
    margin: 30px 0;
    background: #ffffff;
    position: relative;
    z-index: 1;
    padding-right: 21px;
        }
    ::after {
            content: '';
    display: block;
    height: 1px;
    background-color: #979797;
    position: absolute;
    width: 100%;
    top: 50%;
        }
    `
const Body = styled.div``
const RequestDate = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 30px;
`
const RecurrencePattern = styled.div`
   
`
const BoxWrapper = styled.div``
const RangeofRecurrence = styled.div``
const PatternWrapper = styled.div`
    padding: 15px 15px 0;
    border-radius: 10px;
`
const RadioWrapper = styled.div`
    display: flex;
    flex:1;
    margin-bottom: 10px;
    >div{
      padding-right: 20px;
    }
`
const RadioData = styled.div`
    flex:1;
`
const TheDaySection = styled.div`
  display: flex;
  > div {
    flex:1;
    :first-child {
      text-align: left;
    }
  }
  .app-input-text input{
    color: rgba(0, 0, 0, 0.54);
  }
  .app-input-text textarea{
    color: rgba(0, 0, 0, 0.54);
  }
`
const NoDay = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
      p {
        margin:0;
      }
  .app-input-text {
    margin: 0;
    flex: 1;
    textarea{
      margin-top: 10px;
    }
    input {
      text-align: left;
    }
  }

`

const TheDay = styled.div`
  display: flex;
  gap: 10px;
  p {
    margin:0;
  }
  > div {
    flex:1;
    :first-child {
    }
    :nth-child(2) {   
    }
  }

`
export { Container, Heading, Body, RequestDate, RecurrencePattern, ModalContainer, BoxWrapper, RangeofRecurrence, PatternWrapper, RadioWrapper, RadioData, TheDaySection, NoDay, TheDay };